import { useCallback, useContext } from 'react';

import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { EXTRA_ACTIVITY_MANAGEMENT_ENABLED } from 'constants/featureFlags';
import { ActiveElementsContext } from 'global/ActiveElements/ActiveElementsContext';

import { ACTIVITY_LAYOUT_VARIANTS } from './const';
import AbsenceLayout from './LayoutVariants/AbsenceLayout';
import ActivityLayout from './LayoutVariants/ActivityLayout';
import ExtraActivityLayout from './LayoutVariants/ExtraActivityLayout';
import RestLayout from './LayoutVariants/RestLayout';
import RroTimeOffAvailabilityDisabledLayout from './LayoutVariants/RroTimeOffAvailabilityDisabledLayout';
import RroTimeOffAvailabilityEnabledLayout from './LayoutVariants/RroTimeOffAvailabilityEnabledLayout';
import ShiftTailLayout from './LayoutVariants/ShiftTailLayout';
import getActivityConfig from './utils/ChipConfigUtil';
import {
	getDeleteExtraActivityPayload,
	getExtraActivityActions,
} from './utils/extraActivityActions';

const ActivityChip = ({
	timezone,
	record = {},
	isStartInTimeWindow = true,
	isEndInTimeWindow = true,
	suppressNativeTitle = false,
	extraActivityManagement = null,
	onExtraActivityManagementInteractionChange,
}) => {
	const active = useContext(ActiveElementsContext);
	const activityConfig = getActivityConfig({ ...record });
	const openDeleteExtraActivity = useCallback(
		(activityRecord) => {
			active?.setActiveElement(
				MODAL_NAMES.deleteExtraActivity,
				getDeleteExtraActivityPayload(activityRecord)
			);
		},
		[active]
	);

	const { layoutVariant } = activityConfig;
	const edgeProps = { isStartInTimeWindow, isEndInTimeWindow, suppressNativeTitle };

	switch (layoutVariant) {
		case ACTIVITY_LAYOUT_VARIANTS.extraActivity:
			return (
				<ExtraActivityLayout
					actions={
						EXTRA_ACTIVITY_MANAGEMENT_ENABLED && active
							? getExtraActivityActions(record, openDeleteExtraActivity)
							: []
					}
					config={activityConfig}
					timezone={timezone}
					onActionMenuInteractionChange={onExtraActivityManagementInteractionChange}
					{...edgeProps}
				/>
			);

		case ACTIVITY_LAYOUT_VARIANTS.rest:
			return <RestLayout config={activityConfig} timezone={timezone} {...edgeProps} />;

		case ACTIVITY_LAYOUT_VARIANTS.absence:
			return <AbsenceLayout config={activityConfig} timezone={timezone} {...edgeProps} />;

		case ACTIVITY_LAYOUT_VARIANTS.rroTimeOffAvailabilityEnabled:
			return <RroTimeOffAvailabilityEnabledLayout config={activityConfig} {...edgeProps} />;

		case ACTIVITY_LAYOUT_VARIANTS.rroTimeOffAvailabilityDisabled:
			return <RroTimeOffAvailabilityDisabledLayout config={activityConfig} {...edgeProps} />;

		case ACTIVITY_LAYOUT_VARIANTS.shiftTail:
			return <ShiftTailLayout />;

		case ACTIVITY_LAYOUT_VARIANTS.idle:
			return null;

		case ACTIVITY_LAYOUT_VARIANTS.activity:
		default:
			return (
				<ActivityLayout
					config={activityConfig}
					timezone={timezone}
					extraActivityManagement={extraActivityManagement}
					onExtraActivityManagementInteractionChange={onExtraActivityManagementInteractionChange}
					{...edgeProps}
				/>
			);
	}
};

export default ActivityChip;
